import React from 'react'
import { Link } from 'react-router-dom'
import { ST_DIAGNOSTIC_PATH } from './softwareTesting/StDiagnostic'

const courseGroups = [
  {
    title: 'Foundation Courses',
    icon: 'bi-mortarboard-fill',
    theme: { c1: '#B4DEBD', c2: '#5fa870', rgb: '180,222,189' },
    courses: [
      { title: 'Mathematics 1',          icon: 'bi-calculator', to: '/math' },
      { title: 'Mathematics 2',          icon: 'bi-calculator', to: '/math2' },
      { title: 'Statistics 1',           icon: 'bi-bar-chart', to: '/statistics' },
      { title: 'Statistics 2',           icon: 'bi-bar-chart', to: '/statistics2' },
      { title: 'Computational Thinking', icon: 'bi-cpu', to: '/computational-thinking' },
    ],
  },
  {
    title: 'Programming Courses',
    icon: 'bi-code-square',
    theme: { c1: '#91C4C3', c2: '#4f9594', rgb: '145,196,195' },
    courses: [
      { title: 'Java',   icon: 'bi-cup-hot-fill', to: '/programming/courses/java' },
      { title: 'Python', icon: 'bi-filetype-py', to: '/programming/courses/python' },
      { title: 'DBMS',   icon: 'bi-database-fill', to: '/programming/courses/dbms' },
      { title: 'PDSA',   icon: 'bi-diagram-3-fill', to: '/programming/courses/pdsa' },
    ],
  },
   {
    title: 'Data Science',
    icon: 'bi-graph-up-arrow',
    theme: { c1: '#B9A6D6', c2: '#7a62a8', rgb: '185,166,214' },
    courses: [
      { title: 'ML Foundations', icon: 'bi-cpu-fill', to: '/data-science/ml-foundations' },
    ],
  },
  {
    title: 'Competitive Exam Courses',
    icon: 'bi-trophy',
    theme: { c1: '#80A1BA', c2: '#4a7390', rgb: '128,161,186' },
    courses: [
      { title: 'SAT',          icon: 'bi-pencil-fill', to: '/courses/sat' },
      { title: 'GRE',          icon: 'bi-mortarboard-fill', to: '/courses/gre' },
      { title: 'GMAT',         icon: 'bi-briefcase-fill', to: '/courses/gmat' },
      { title: 'ACT',          icon: 'bi-journal-richtext', to: '/courses/act' },
      { title: 'CAT',          icon: 'bi-journal-check', to: '/courses/cat' },
      { title: 'JEE Main',     icon: 'bi-mortarboard-fill', to: '/courses/jee-main' },
      { title: 'JEE Advanced', icon: 'bi-trophy-fill', to: '/courses/jee' },
      { title: 'GATE DA',      icon: 'bi-cpu-fill', to: '/courses/gate-da' },
    ],
  },
  {
    title: 'Exams & Practice',
    icon: 'bi-clipboard-check',
    theme: { c1: '#B9A6D6', c2: '#7a62a8', rgb: '185,166,214' },
    courses: [
      { title: 'Software Diagnostic Layer 1', icon: 'bi-bug-fill', to: ST_DIAGNOSTIC_PATH, action: 'Start Exam' },
      { title: 'Writing a Program — Practice', icon: 'bi-code-slash', to: '/practice/writing-programs', action: 'Start Practice' },
    ],
  },
]

const homeCourseStyles = `
  .home-group { background: linear-gradient(180deg, rgba(var(--g-rgb),0.09) 0%, rgba(var(--g-rgb),0.02) 100%);
    border: 1px solid rgba(var(--g-rgb),0.18); border-radius: 18px; padding: 1.75rem 1.5rem 0.5rem;
    margin-bottom: 2.5rem; }
  .home-group-title { display: inline-flex; align-items: center; gap: 12px; margin-bottom: 1.5rem;
    background: linear-gradient(135deg, var(--g1) 0%, var(--g2) 100%); color: #fff;
    padding: 8px 22px 8px 8px; border-radius: 50px; font-size: 1.15rem; font-weight: 600;
    letter-spacing: 0.02em; box-shadow: 0 8px 18px rgba(var(--g-rgb),0.45);
    text-shadow: 0 1px 2px rgba(0,0,0,0.18); }
  .home-group-title i { width: 36px; height: 36px; border-radius: 50%; background: #fff;
    color: var(--g2); display: flex; align-items: center; justify-content: center; font-size: 1.1rem; }
  .home-group-count { background: rgba(255,255,255,0.25); border-radius: 50px; padding: 2px 10px;
    font-size: 0.8rem; font-weight: 500; }
  .home-course-card { background: rgba(var(--g-rgb),0.28);
    border: 1px solid rgba(var(--g-rgb),0.7); border-top: 4px solid var(--g2);
    border-radius: 14px; padding: 1.5rem; height: 100%; box-shadow: 0 4px 12px rgba(0,0,0,0.04);
    transition: transform 0.3s, box-shadow 0.3s, border-color 0.3s; }
  .home-course-card:hover { transform: translateY(-6px); border-color: var(--g1);
    box-shadow: 0 14px 26px rgba(var(--g-rgb),0.25); }
  .home-course-card h5 { color: var(--heading-color); font-weight: 600; }
  .home-course-icon { width: 60px; height: 60px; border-radius: 14px; display: flex; align-items: center;
    justify-content: center; font-size: 1.7rem; margin-bottom: 1rem;
    background: rgba(var(--g-rgb),0.6); color: var(--g2); transition: background 0.3s, color 0.3s; }
  .home-course-card:hover .home-course-icon { background: linear-gradient(135deg, var(--g1) 0%, var(--g2) 100%);
    color: #fff; }
  .home-course-btn { background: linear-gradient(135deg, var(--g1) 0%, var(--g2) 100%); color: #fff;
    border: none; border-radius: 50px; padding: 6px 20px; font-size: 0.9rem; font-weight: 500;
    box-shadow: 0 4px 10px rgba(var(--g-rgb),0.3); transition: filter 0.2s; }
  .home-course-btn:hover { color: #fff; filter: brightness(1.08); }
`

const Home = () => {
  return (
    <main className="main" style={{ marginTop: 0, paddingTop: 0 }}>
      {/* Hero Section */}
      <section id="hero" className="hero section">
        <img src="/img/Index Page Images.png" alt="" data-aos="fade-in" />
        
        <div className="container">
          <h2 data-aos="fade-up" data-aos-delay="100" className="">
            Learning Today,<br />Leading Tomorrow
          </h2>
          <p data-aos="fade-up" data-aos-delay="200">
            Educating Minds, Empowering Futures.
          </p>
          <div className="d-flex mt-4" data-aos="fade-up" data-aos-delay="300">
            <Link to="/about" className="btn-get-started">Learn More</Link>
          </div>
        </div>
      </section>

      {/* Courses Section */}
      <section id="courses" className="courses section">
        {/* Section Title */}
        <div className="container section-title" data-aos="fade-up">
          <h2>Courses</h2>
          <p className="">Popular Courses</p>
        </div>

        <style>{homeCourseStyles}</style>
        <div className="container">
          {courseGroups.map((group) => (
            <div
              className="home-group"
              key={group.title}
              data-aos="fade-up"
              style={{ '--g1': group.theme.c1, '--g2': group.theme.c2, '--g-rgb': group.theme.rgb }}
            >
              <h5 className="home-group-title">
                <i className={`bi ${group.icon}`}></i>{group.title}
                <span className="home-group-count">{group.courses.length} courses</span>
              </h5>
              <div className="row">
                {group.courses.map((course) => (
                  <div className="col-lg-3 col-md-4 col-sm-6 mb-4" key={course.title}>
                    <div className="home-course-card">
                      <div className="home-course-icon">
                        <i className={`bi ${course.icon}`}></i>
                      </div>
                      <h5 className="mb-3">{course.title}</h5>
                      <Link to={course.to} className="btn home-course-btn">{course.action || 'Start Learning'}</Link>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="about section">
        <div className="container">
          <div className="row gy-4">
            <div className="col-lg-6 order-1 order-lg-2" data-aos="fade-up" data-aos-delay="100">
              <img src="/img/Index page Image2.png" className="img-fluid" alt="About Sanghamitra Learning" />
            </div>

            <div className="col-lg-6 order-2 order-lg-1 content" data-aos="fade-up" data-aos-delay="200">
              <h3>Empowering Marginalized Learners: Our Mission to Democratize Education</h3>
              <p className="fst-italic">
                Breaking Barriers, Unlocking Potential
              </p>
              <ul>
                <li><i className="bi bi-check-circle"></i> <span>On our platform, we are dedicated to democratizing education by breaking down barriers and providing equal opportunities for all.</span></li>
                <li><i className="bi bi-check-circle"></i> <span>Our primary goal is to offer high-quality education to marginalized students who may otherwise lack access to competitive advantages.</span></li>
                <li><i className="bi bi-check-circle"></i> <span>Through our platform, we aim to bridge the gap by providing resources, support, and opportunities for personal and academic growth. By doing so, we strive to empower individuals from underserved communities to reach their full potential and pursue their dreams. Join us in our mission to create a more inclusive and equitable educational landscape for all learners.</span></li>
              </ul>
              <Link to="/about" className="read-more"><span>Read More</span><i className="bi bi-arrow-right"></i></Link>
            </div>
          </div>
        </div>
      </section>

      {/* Why Us Section */}
      <section id="why-us" className="section why-us">
        <div className="container">
          <div className="row gy-4">
            <div className="col-lg-4" data-aos="fade-up" data-aos-delay="100">
              <div className="why-box">
                <h3>Why Choose Our Products?</h3>
                <p>
                  Innovative AI-driven Feedback: Our platform offers personalized responses tailored to each individual test-taker's performance. Leveraging advanced algorithms, we provide specific feedback to maximize improvement and enhance learning outcomes. Experience the power of tailored guidance on your educational journey.
                </p>
                <div className="text-center">
                  <Link to="/about" className="more-btn"><span>Learn More</span> <i className="bi bi-chevron-right"></i></Link>
                </div>
              </div>
            </div>

            <div className="col-lg-8 d-flex align-items-stretch">
              <div className="row gy-4" data-aos="fade-up" data-aos-delay="200">
                <div className="col-xl-4">
                  <div className="icon-box d-flex flex-column justify-content-center align-items-center">
                    <i className="bi bi-clipboard-data"></i>
                    <h4>Innovative AI-driven Feedback</h4>
                    <p>Unlock your potential with AI-driven Feedback, ensuring personalized guidance for optimal improvement.</p>
                  </div>
                </div>

                <div className="col-xl-4" data-aos="fade-up" data-aos-delay="300">
                  <div className="icon-box d-flex flex-column justify-content-center align-items-center">
                    <i className="bi bi-gem"></i>
                    <h4>Quality Content</h4>
                    <p> Explore our platform's treasure trove of Quality Content, curated to enrich your learning experience.</p>
                  </div>
                </div>

                <div className="col-xl-4" data-aos="fade-up" data-aos-delay="400">
                  <div className="icon-box d-flex flex-column justify-content-center align-items-center">
                    <i className="bi bi-inboxes"></i>
                    <h4>Myriad Assessments</h4>
                    <p>Dive into Myriad Assessments, offering diverse challenges to gauge and enhance your knowledge.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  )
}

export default Home
